import * as _4 from 'lodash4';

export function MyIntakeModelConfiguration(myIntakeModelProvider: any, ItemPresenterEnum: any, ngProgression: any) {
  myIntakeModelProvider.configure({
    createProgression(model: { pages: object[] }) {
      const pageCount: number[] = [];

      _4.forEach(model.pages, (item: any, index: number) => {
        const countOfListSelectionQuestionsOnPage = _4.reduce(
          item.children,
          (count: number, child: any) => {
            return count + (ItemPresenterEnum.isEqual(child.presenter, ItemPresenterEnum.LISTSELECTION) ? 1 : 0);
          },
          0
        );

        pageCount.push(index);
        if (countOfListSelectionQuestionsOnPage > 0) {
          pageCount.push(index);
        }
      });

      const extendedProgression = new ngProgression(pageCount);
      extendedProgression.isSecondListSelectionPage = function isSecondListSelectionPage() {
        return this.current() === this.peekPrevious();
      };

      return extendedProgression;
    }
  });
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/configs/my_intake_model_configuration.ts